import { MediaType } from '../components/Chat/Chat.enum';

export function getMediaTypeImage(mimeType: string) {
  let mediaType = MediaType.DOCUMENT;

  if (mimeType.includes('image')) {
    mediaType = MediaType.IMAGE;
  }

  if (mimeType.includes('video')) {
    mediaType = MediaType.VIDEO;
  }

  if (mimeType.includes('audio')) {
    mediaType = MediaType.AUDIO;
  }

  return mediaType;
}
